import Button from "@mui/material/Button";
import { Divider } from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";
import * as yup from "yup";
import { InitialPathContext, routes, useExtendedForm } from "../common";
import { AuthContext } from "./useAuth";
import { AuthPage } from "./components";
import { useContext } from "react";

const PRIVACY_POLICY_URL = "https://nowbuttons.com/legal/privacy/";
const TERMS_CONDITIONS_URL = "https://nowbuttons.com/legal/terms/";
const DPA_URL = "https://nowbuttons.com/legal/gdpr/dpa/";

const initialValues = {
  email: "",
  emailOptIn: false,
};

const schema = yup
  .object<typeof initialValues>()
  .shape({
    email: yup.string().email().required("email is missing"),
  })
  .defined();

const MagicSignupPage = () => {
  const { register, requestMagicLink } = useContext(AuthContext);
  const { initialPath } = useContext(InitialPathContext);
  const formal = useExtendedForm({
    initialValues,
    schema,
    onSubmit: async (values) => {
      await register(
        values.email,
        undefined,
        values.emailOptIn,
        new URLSearchParams(
          initialPath?.substring(initialPath.indexOf("?")),
        ).get("utm_source") ?? "web",
      );
      await requestMagicLink(values.email);
    },
  });

  return (
    <AuthPage>
      <form {...formal.getFormProps()}>
        <FormGroup>
          <Typography variant="h5" align="center" paragraph>
            Get started for free!
          </Typography>
          <TextField
            label="Email address"
            type="email"
            {...formal.getTextFieldProps("email")}
          />
          <p>
            <Button
              variant="contained"
              size="large"
              color="primary"
              fullWidth
              {...formal.getSubmitButtonProps()}
              type="submit"
            >
              Sign Up
            </Button>
            {formal.submitState.state === "error" && (
              <FormHelperText error>
                {formal.submitState.message ||
                  "Server error: couldn't register this user"}
              </FormHelperText>
            )}
          </p>
          <Typography sx={{ fontSize: 12 }}>
            By clicking 'Sign Up', you agree to our{" "}
            <Link
              sx={{ color: "#7d7d7d", textDecoration: "underline" }}
              target="_blank"
              href={TERMS_CONDITIONS_URL}
            >
              Terms of Service
            </Link>{" "}
            (including the{" "}
            <Link
              sx={{ color: "#7d7d7d", textDecoration: "underline" }}
              target="_blank"
              href={DPA_URL}
            >
              Data Processing Agreement
            </Link>{" "}
            ) and acknowledge our{" "}
            <Link
              sx={{ color: "#7d7d7d", textDecoration: "underline" }}
              target="_blank"
              href={PRIVACY_POLICY_URL}
            >
              Privacy Policy
            </Link>
            .
          </Typography>
          <Divider sx={{ my: 4 }} />
          <Typography variant="body1" align="center">
            Already have an account?{" "}
            <Link component={RouterLink} to={routes.LOGIN.path}>
              Sign In
            </Link>
          </Typography>
        </FormGroup>
      </form>
    </AuthPage>
  );
};

export default MagicSignupPage;
